import React, { useState } from 'react';
import { XIcon } from 'assests/GmsIcons';
import { ENTER_NAME } from 'Pages/GMS/ISR/ISRConstants';

type CreateListDialogProps = {
    dialogHeader: string;
    labelName: string;
    value?: string;
    actionLabel?: string;
    onClose: () => void;
    onSubmit: (name: string) => void;
    showIndicator?: boolean;
    message?: string;
}

const CreateListDialog = ({ dialogHeader = "", labelName = "", value, onClose, onSubmit, actionLabel, showIndicator = false, message }: CreateListDialogProps) => {
    const [name, setName] = useState(value ?? '');

    const handleOnCreateClick = () => {
        onSubmit(name);
        setName("");
    };

    const handleSubmodelFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(event.target.value);
    };

    return (
        <div className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-1/4 tw-h-auto`}>
                <div className='tw-flex tw-justify-between tw-items-center'>
                    <div className='tw-flex tw-items-center tw-gap-10'>
                        <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>{dialogHeader}</h2>
                    </div>
                    <button className='tw-mr-2' onClick={onClose}><XIcon /></button>
                </div>

                <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />
                <div className={`tw-px-3  tw-my-3 `}>
                    <label className={`tw-font-normal tw-w-full tw-text-sm tw-ps-1`}>{labelName}</label>
                    <div className="tw-relative">
                        <input
                            className='className={`tw-w-auto tw-min-w-full tw-border tw-border-[#EBECF0] tw-text-xs tw-block tw-py-2 tw-px-3 tw-m-1 tw-bg-[#fff] tw-bg-clip-padding tw-text-[#6B778C] focus:tw-text-gray-700 tw-rounded-[4px] tw-flex-grow tw-font-normal tw-shadow-none`}'
                            onChange={handleSubmodelFieldChange}
                            id="create_list"
                            type="text"
                            value={name}
                            placeholder={ENTER_NAME} />
                    </div>
                </div>
                <div className='tw-flex tw-justify-between tw-item-center tw-px-2 tw-py-3'>
                    {message && <div className='tw-mb-3 tw-ms-2'>{showIndicator ? <label className='tw-text-[#747593] tw-text-sm'>{message}</label> : null}</div>}
                    <div className={`tw-flex tw-gap-2 tw-justify-end`}>
                        <button onClick={onClose} className='samll-outline-btn'>Done</button>
                        <button disabled={name === ""} onClick={handleOnCreateClick} className={`small-filled-btn`}>{actionLabel ?? 'Create'}</button>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default CreateListDialog;